import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { moreTestimonials } from '../data/testimonials';
export function MoreTestimonials() {
  return <section aria-label="More testimonials" className="mx-auto mt-12 w-full max-w-5xl" data-id="element-103" data-mp="20fowudtw93h2">
      <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-104" data-mp="25auta6kxa0je">
        💜 More families already using the system
      </h2>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-105" data-mp="1ckvzjxvs9f8e">
        {moreTestimonials.map((t, i) => <TestimonialCard key={t.name} testimonial={t} delay={i % 2 * 0.1} data-id="element-106" data-mp="1hk8k2bz6ma7t" data-mpi={i} />)}
      </div>
    </section>;
}